import {createAction} from 'redux-actions'

export const fetch = createAction('PGM/LIST/FETCH')
export const receive = createAction('PGM/LIST/RECEIVE', null, (_, panelId) => ({panelId}))
export const startPoll = createAction('PGM/LIST/POLL/START')
export const stopPoll = createAction('PGM/LIST/POLL/STOP')
